import { NOTEMESSAGE } from "../../../../constants";
import { NoteMessageContainer } from "../../../../Layout/Common/alert/noteMessageContainer";
import { NotificationNumber } from "./NotificationNumber";
import { PickupLocation } from "./PickupLocation";

export const ShopCounterPickup = ({ isPickupOnly }) => {
  const { SHIPPINGNOTAVAILABLE } = NOTEMESSAGE;

  return (
    <div className="tab-pane fade" id="pills-store" role="tabpanel" aria-labelledby="pills-store-tab">
      {isPickupOnly && isPickupOnly == true && (
        <NoteMessageContainer
          heading={SHIPPINGNOTAVAILABLE.title}
          contant={SHIPPINGNOTAVAILABLE.content}
          className="yellow-note-container"
        />
      )}
      <PickupLocation />
      <NotificationNumber />
    </div>
  );
};
